import * as React from 'react';
import './styles.css';
import Close from '@material-ui/icons/Close';
import ArrowForward from '@material-ui/icons/ArrowForward';
import { Loader } from '../Loader/Loader';
import { observer } from 'mobx-react';
import {FormControl, InputLabel, MenuItem, Select, TextField} from "@material-ui/core";
import {Order} from "../../models/order";

export interface IManuallyCompleteOrderDialogProps {
    onCancel(): void
    onOk(reason: string): void
    prompt: string
    title: string
}

interface State {
  reason: string
  otherReason: string
}

@observer
export class ManuallyCompleteOrderDialog extends React.Component<IManuallyCompleteOrderDialogProps, State> {

    constructor(props: IManuallyCompleteOrderDialogProps) {
        super(props);

        this.state = {
          reason: '',
          otherReason: ''
        }
    }

    public render() {
        return <div className="full-dialog">
            <Loader area="submit-workflow-dialog" />
            <div className="dialog-content">
                <h3>{this.props.title}</h3>
                <p>{this.props.prompt}</p>

              <FormControl className="reason-select">
                <InputLabel htmlFor='reason'>Reason (optional)</InputLabel>
                <Select
                  disableUnderline
                  value={this.state.reason}
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    this.setState(s => ({ ...s, reason: e.target.value }));
                  }}
                  inputProps={{name: 'reason', id: 'reason'}}
                  autoWidth>
                  {
                    Order.manualCompletionReasons.map(r => (
                      <MenuItem value={r.value} key={r.value}>
                        {r.name}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>

              {this.state.reason === 'Other' &&
                <TextField
                  InputProps={{disableUnderline: true}}
                  label="Please specify"
                  type="text"
                  name="otherReason"
                  autoComplete="no"
                  value={this.state.otherReason}
                  onChange={e => {
                    this.setState(s => ({ ...s, otherReason: e.target.value }));
                    e.persist();
                  }}
                  fullWidth
                />
              }
            </div>
            <div className="dialog-actions">
                <div className="close" onClick={this.props.onCancel}>
                    <span>Cancel</span>
                    <Close className="icon" />
                </div>
                <div className="done" onClick={() =>
                  this.props.onOk(this.state.reason === 'Other'
                    ? this.state.otherReason
                    : this.state.reason)}>
                    <span>Ok</span>
                    <ArrowForward className="icon" />
                </div>
            </div>
        </div>
    }
}
